import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { actions } from '@/store/allocations/actions';
import { getters } from '@/store/allocations/getters';
import { mutations } from '@/store/allocations/mutations';
import { AllocationState } from '@/store/allocations/types';

const state: AllocationState = {
  selected: undefined,
  activeAllocations: undefined,
  inactiveAllocations: undefined,
  exclusionRules: undefined,
  donorDetails: undefined,
  recipientDetails: undefined,
  checklist: undefined,
  checklistDetails: undefined,
  checklistHistory: undefined,
  // loading state flags used across components
  isCreatingAllocation: false,
  isLoadingAllocation: false,
  isLoadingAllocations: false,
  isAllocationCompletion: false,
  isGeneratingAllocationReport: false,
  isAddingRecipient: false,
  isDiscontinuingOneAllocation: false,
  isDiscontinuingAllAllocations: false,
  isMakingOffer: false,
  isDiscontinuingOneOffer: false,
  isRespondingOffer: false,
  isDecliningMultiple: false,
};

const namespaced = true;

export const allocations: Module<AllocationState, RootState> = {
  namespaced,
  mutations,
  actions,
  getters,
  state
};
